<template lang="pug">
    span(
        class="__affirm-logo"
        :class="[color === 'white' ? '__affirm-logo-white' : '__affirm-logo-blue']"
        :style="{ height: height === 0 ? 'auto' : height + 'px' }"
    ) Affirm
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: 'blue',
        },
        height: {
            type: Number,
            default: 0,
        },
    },
    mounted() {
        this.$affirm.load()
    },
}
</script>
